


























import {Component, Prop, Vue} from "vue-property-decorator";
import {Element} from "@api/models/Element";
import SessionListItem from "@share/program/components/session-list/SessionListItem.vue";

@Component({
    name: "FavoritesList",
    components: {SessionListItem}
})
export default class FavoritesList extends Vue {
    @Prop({ required: true }) sessions: Element[];
    @Prop({ required: false, default: null }) activeSessionId: string | null;
    @Prop({default: false}) isLoading: boolean;

    currentSession: Element | null = null;

    select(sessionId: string, selectedByClick: boolean) {

        if(window.innerWidth < 1024) {
            selectedByClick && this.$emit('select', sessionId);
        }
        else {
            !selectedByClick && this.$emit('select', sessionId);
        }
    }

    close() {
        setTimeout(() => {
            this.$emit('close')
        }, 500)
    }
}
